import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  root: {
    margin: theme.spacing(0, 2),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  chart: {
    minHeight: 240,
  },
}));
